export default "__VITE_ASSET__DmSoqJYc__"